<div class="col-12 mt-2" *ngIf="testes.length > 0">
    <h2 class="titulo-tipo">
        {{ tipoTesteLabels[tipo] }}:
    </h2>
</div>

<div class="carousel-wrapper">

    <button class="nav-btn left" *ngIf="!isAtStart" (click)="scrollLeft()">
        ❮
    </button>

    <div class="testes-container" #scrollContainer (scroll)="onScroll()">

        <ng-container *ngIf="tipo == tipoTesteEnum.RECRUTAMENTO_E_SELECAO">
            <div class="teste-item" *ngFor="let licenca of licencas">
                <card-licenca [licenca]="licenca"></card-licenca>
            </div>
        </ng-container>


        <ng-container *ngIf="tipo != tipoTesteEnum.RECRUTAMENTO_E_SELECAO">
            <div class="teste-item" *ngFor="let teste of testes">
                <card-teste (onIniciarClick)="irParaGrupo($event)" [teste]="teste">
                </card-teste>
            </div>
        </ng-container>

        <!-- Skeleton loader -->
        <ng-container *ngIf="loadingMore">
            <div class="teste-item skeleton" *ngFor="let i of [1,2,3]"></div>
        </ng-container>

    </div>

    <button class="nav-btn right" *ngIf="!isAtEnd" (click)="scrollRight()">
        ❯
    </button>

</div>